import '../../shared/sailing-camp/camp';
